import Crud from '@/views/Holiday/Crud'
import Add from '@/views/Holiday/Add'

const routes = {
  path: '/holidays',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/holidays',
      name: 'list-feriados',
      component: Crud,
    },
    {
      path: '/holidays/add',
      name: 'Feriado',
      component: Add,
    },
    {
      path: '/holidays/edit/:id?',
      name: 'Feriado',
      component: Add,
    },
  ],
}

export default routes
